function f(n: number, k: number, g: (a: number[]) => void, history: number[] = []) {
  if (k == 0) {
    g(history)
  }
  const min = history.length > 0 ? history[history.length - 1] + 1 : 0
  for (let i = min; i < n; ++i) {
    f(n, k - 1, g, [...history, i])
  }
}

export { f as generateCombinations }